export default __webpack_public_path__ + "book_details-isbn13.39ad8135.png";